module.exports = __webpack_public_path__ + "img/36924-001.0d5b6ab8.jpg";